import { Row, Col, Modal, Form, Input, Select, Button } from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined, PlusOutlined, MinusOutlined } from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";

const AddFrom = ({
  path,
  sectionName,
  show,
  hide,
  data,
  refresh,
  isUpdate,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) {
      form.setFieldsValue({
        name: "",
        description: "",
        subTagsData: [{ subTagsName: "", subTags: [] }],
      });
      return;
    }

    form.setFieldsValue({
      ...data,
      name: data?.name,
      subTagsData: data?.subTagsData?.length > 0 ? data.subTagsData : [{ subTagsName: "", subTags: [] }],
    });
  }, [data, form]);

  const onCreate = (values) => {
    const { name, description, subTagsData } = values;

    const filteredSubTagsData = (subTagsData || []).filter(
      (item) => (item.subTagsName && item.subTagsName.trim() !== "") || (item.subTags && item.subTags.length > 0)
    );

    const payload = {
      name,
      description,
      subTagsData: filteredSubTagsData,
    };

    setLoading(true);
    if (isUpdate) {
      request({
        url: `${apiPath.updateSkillTag}/${data._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      request({
        url: `${apiPath.addSkillTag}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  return (
    <Modal
      width={600}
      open={show}
      title={`${
        data
          ? lang("Update") + " " + sectionName
          : lang("Add") + " " + lang("New") + " " + sectionName
      }`}
      okText={`${data ? lang("Update") : lang("Add")}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ subTagsData: [{ subTagsName: "", subTags: [] }] }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Skill Tag"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please Enter The Skill Name",
                },
              ]}
            >
              <Input placeholder="Enter The Skill Name" />
            </Form.Item>
            <Form.Item className="mb-1" label="Description" name="description">
              <TextArea placeholder="Enter The Description" />
            </Form.Item>

            <Form.List name="subTagsData">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div
                      key={key}
                      style={{
                        marginBottom: 16,
                        padding: 16,
                        border: "1px dashed #ccc",
                        position: "relative",
                        borderRadius: "8px"
                      }}
                    >
                      <Button 
                        type="primary" 
                        style={{
                          position: "absolute",
                          right: 5,
                          top: 5,
                          background: "#2f3542",
                          borderColor: "#2f3542",
                          zIndex: 1,
                          width:"25px",
                          padding:"0px "
                        }} 
                        className="minus-button-mainjhj"
                        icon={<MinusOutlined />} 
                        onClick={() => remove(name)} 
                      />
                      
                      <Form.Item
                        {...restField}
                        className="mb-1"
                        label={`Sub Tags Name ${index > 0 ? index + 1 : ""}`}
                        name={[name, "subTagsName"]}
                      >
                        <Input placeholder="Enter Sub Tags Name"  />
                      </Form.Item>
                      
                      <Form.Item
                        {...restField}
                        className="mb-1"
                        label={`Sub Tags ${index > 0 ? index + 1 : ""}`}
                        name={[name, "subTags"]}
                      >
                        <Select
                          mode="tags"
                          style={{ width: "100%" }}
                          placeholder="Enter Sub Tags"
                          tokenSeparators={[","]}
                        />
                      </Form.Item>
                    </div>
                  ))}
                  {fields.length < 3 && (
                    <Form.Item>
                      <Button
                        // type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Add More Sub Tags
                      </Button>
                    </Form.Item>
                  )}
                </>
              )}
            </Form.List>

          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFrom;
